import React, {useState} from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import './SapFinanceLearningJourney.css'

const SapFinanceLearningJourney = () => {
    const [value, setValue] = useState('1');
    const handleChange = (event, newValue) => {
        setValue(newValue);
      };
  return (
    <>
    <div className='learning-Journey-container'>
    <h2>SAP Finance Learning Journey</h2>
    <div className='lj-menu-wrapper'>
        <Box sx={{ width: '100%', typography: 'body1' }} >
        <TabContext value={value}>
          <Box>
            <TabList onChange={handleChange} className="main-list" variant="scrollable" scrollButtons="auto" aria-label="lab API tabs example">
              <Tab label="SAP Finance Consultant" value="1" className='list2 item'/>
            </TabList>
          </Box>
          <div className="lj-box">
          <TabPanel value="1">
            {/* <div className='lj-images'>
                <img src='images/SapFinance/SAP-FI-lj.png' alt='overall-img' className='lj-images' />
            </div> */}
            <div className='LJ-link-Wrapp'>
                  <img src='images/SapFinance/LearningJourney/SAPFIiphases.png' alt='aware-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='SAP-Finance'>
                    <p className='link1'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=410S-HVYS-CHE8-80AN-463Q-WIC1-CP4A-WV4T&linkId=ITEM_DETAILS&componentID=TERP20_EN_Col17&componentTypeID=E-Learning&fromSF=Y&revisionDate=1357992000000" target="_blank"><img src='images/SapFinance/LearningJourney/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=410S-HVYS-CHE8-80AN-463Q-WIC1-CP4A-WV4T&linkId=ITEM_DETAILS&componentID=AC010e_EN_Col15&componentTypeID=E-Learning&fromSF=Y&revisionDate=1357992000000" target="_blank"><img src='images/SapFinance/LearningJourney/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=410S-HVYS-CHE8-80AN-463Q-WIC1-CP4A-WV4T&linkId=ITEM_DETAILS&componentID=AC200e_EN_Col15&componentTypeID=E-Learning&fromSF=Y&revisionDate=1357992000000" target="_blank"><img src='images/SapFinance/LearningJourney/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=410S-HVYS-CHE8-80AN-463Q-WIC1-CP4A-WV4T&linkId=ITEM_DETAILS&componentID=AC201e_EN_Col15&componentTypeID=E-Learning&fromSF=Y&revisionDate=1357992000000" target="_blank"><img src='images/SapFinance/LearningJourney/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=410S-HVYS-CHE8-80AN-463Q-WIC1-CP4A-WV4T&linkId=ITEM_DETAILS&componentID=AC202_EN_Col15&componentTypeID=e-book&fromSF=Y&revisionDate=1358251200000" target="_blank"><img src='images/SapFinance/LearningJourney/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=410S-HVYS-CHE8-80AN-463Q-WIC1-CP4A-WV4T&linkId=ITEM_DETAILS&componentID=AC207_EN_Col98&componentTypeID=Handbooks&fromSF=Y&revisionDate=1357992000000" target="_blank"><img src='images/SapFinance/LearningJourney/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=410S-HVYS-CHE8-80AN-463Q-WIC1-CP4A-WV4T&linkId=ITEM_DETAILS&componentID=AC305_EN_Col15&componentTypeID=e-book&fromSF=Y&revisionDate=1358078400000" target="_blank"><img src='images/SapFinance/LearningJourney/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=410S-HVYS-CHE8-80AN-463Q-WIC1-CP4A-WV4T&linkId=ITEM_DETAILS&componentID=AC205_EN_Col15&componentTypeID=e-book&fromSF=Y&revisionDate=1358078400000" target="_blank"><img src='images/SapFinance/LearningJourney/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=410S-HVYS-CHE8-80AN-463Q-WIC1-CP4A-WV4T&linkId=ITEM_DETAILS&componentID=CA700e_EN_Col15&componentTypeID=E-Learning&fromSF=Y&revisionDate=1357992000000" target="_blank"><img src='images/SapFinance/LearningJourney/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://saplearninghub.plateau.com/learning/user/deeplink.do?OWASP_CSRFTOKEN=410S-HVYS-CHE8-80AN-463Q-WIC1-CP4A-WV4T&linkId=ITEM_DETAILS&componentID=AC210e_EN_Col15&componentTypeID=E-Learning&fromSF=Y&revisionDate=1357992000000" target="_blank"><img src='images/SapFinance/LearningJourney/10.png'/></a>
                    </p>
                  </div>
                  </div>
                </div>
          </TabPanel>
          </div>
        </TabContext>
      </Box>
    </div>
    </div>
    </>
  )
}

export default SapFinanceLearningJourney